export interface TemplatesTranslationRequestDto {
    id: string;
    translation: string;
    totalTranslation?: string;
}
